// - reactivity for ScheduledTask
// - otherwise, we would have to use something heavier like solid-js
export default class ReactiveTask {
    #task;
    #controller = new AbortController();
    #effect = () => { };
    set(task) {
        if (task === undefined) {
            this.#task = undefined;
            this.#controller.abort();
        }
        else if (this.#task !== task) {
            this.#task = task;
            this.#controller.abort();
            this.#controller = new AbortController();
            this.#effect(this.#task, this.#controller.signal);
        }
    }
    setEffect(effect) {
        this.#effect = effect;
    }
}
